import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const HeaderNumbers = ({ primary = false, className, children, ...props })=>{
    return jsx("div", {
        className: classNames('cb-header-numbers', className, {
            primary
        }),
        ...props,
        children: children
    });
};
HeaderNumbers.displayName = 'Header.Numbers';

export { HeaderNumbers };
//# sourceMappingURL=Header.Numbers.es.js.map
